import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";

import {BaseComponent} from "app/views/base.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {HelperService} from "app/lib/helper.service";
import {ChartParams} from "../../views/chart/chart.component";
import merge from 'lodash-es/merge';
import {LoadStatDetailsModalComponent} from "./load_stat_details.component";
import {PrettyNumberPipe} from "../../pipes/pretty-number.pipe";
import {FilterParams} from "../../models/filter_form.model";
import * as qs from 'qs';
import {parseDate} from "../../lib/lib";
import { SitesService } from "../sites.service";

@Component({
	selector: 'load-stat',
	templateUrl: './load_stat.component.html',
	providers: [PrettyNumberPipe]
})
export class LoadStatComponent extends BaseComponent {
	stats: any;
	chart = new ChartParams();
	statsLoader: boolean = false;
	paginationLoader: boolean = false;
	
	addFilterParams = {
		dateFilters : ['dateLoadStat'],
		
		dateFilterParams: {
			dateLoadStat: {
				start: parseDate().subtract(30, 'day').format('DD-MM-YYYY'),
				end: parseDate().format('DD-MM-YYYY'),
				type: 'other'
			}
		}
	};
	
	totalPages: any = 1;
	currentPage: number = 1;
	CHART_SETTINGS = {};
	
	dontLoad: any = {};
	
	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public route: ActivatedRoute,
		public helper: HelperService,
		public prettyNumber: PrettyNumberPipe,
		public siteService: SitesService
	) {
		super(eventsService, siteService, activatedRoute, filter, translate);
		
		this.chart.setOptions({
			type: 'bar',
			axis: {
				x: {
					type: 'category',
					tick: {
						culling: {
							max: 3
						}
					}
				}
			},
			tooltip: {
				format: {
					title: value => value + ', c',
					value: value => this.prettyNumber.transform(value)
				}
			},
			names: {
				loadTime: this.translate.__A('site.load_stat.all records'),
			}
		});
	}
	
	
	async getData() {
		await this.getChart();
		await this.getStats();
		await this.getPagination();
		
		this.dontLoad = {};
	}
	
	
	async getStats() {
		this.stats = [];
		this.statsLoader = true;
		const { stats } = await this.siteService.loadStat.stats(
			this.filter.filterParams
		).toPromise();
		this.stats = stats;
		this.statsLoader = false;
	}
	
	
	async getChart() {
		if (this.dontLoad.chart) return true;
		
		this.chart.showLoader();
		
		const { charts } = await this.siteService.loadStat.chart(
			this.filter.filterParams
		).toPromise();
		this.chart.data = charts;
		
		this.chart.hideLoader();
	}
	
	
	async getPagination() {
		if (this.dontLoad.pagination) return true;
		
		this.paginationLoader = true;
		const pagination = await this.siteService.loadStat.pagination(
			this.filter.filterParams
		).toPromise();
		this.pagination.fill(pagination);
		
		this.paginationLoader = false;
	}
	
	
	async applyFilters() {
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url    = this.router.url.split('?')[0];
		
		params = qs.stringify(params, { encode: false });
		
		this.router.navigateByUrl(`${url}?${params}`, { relativeTo: this.route });
	}
	
	
	async resetFilters() {
		this.currentPage = 1;
		this.filter.filterParams = new FilterParams();
		this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		
		let params: FilterParams = merge({}, this.filter.getDiffParams(this.filter.filterParams)),
			url = this.router.url.split('?')[0];
		
		delete params.dateFilters;
		delete params.dateFilterParams;
		
		this.router.navigate([url], { relativeTo: this.route, queryParams: params });
	}
	
	
	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;
		
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];
		
		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});
		
		this.dontLoad = {
			chart: true,
			pagination: true
		};
	}
	
	
	async showDetails(host: string) {
		const modalRef = this.modalService.open(LoadStatDetailsModalComponent, {
			title: host,
		}, {size: 'hg'});
		
		modalRef.componentInstance.chart = new ChartParams();
		
		modalRef.componentInstance.chart.showLoader();
		
		const { charts } = await this.siteService.loadStat.chart(
			this.filter.getCopyFilterParams({ siteUrl: host })
		).toPromise();
			
		modalRef.componentInstance.chart.data = charts;
		modalRef.componentInstance.chart.hideLoader();
	}
}
